// Retrieve cookies value

$("input#dogNameInput-0").each(function() {
  if (Cookies.get("dogName")) {
    $(this).val(Cookies.get("dogName"));
    $(".dog-name").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-name").find("button").removeAttr("disabled");
  }
});

$('input[name=dog-0-gender], input[name=dog-0-desexed], input[name=dog-0-ageStage], input[name=dog-eating-habit], input[name=dog-body], input[name=dog-activity], input[name=dog-0-health], input[name=dog-0-no-allergies]').each(function() {
  if (Cookies.get("dogGender")) {
    $('input[name=dog-0-gender][value=' + Cookies.get("dogGender") + ']').prop('checked', true);
    $(".neutered").removeClass("hidden");
  }
  if (Cookies.get("dogNeutered")) {
    $('input[name=dog-0-desexed][value=' + Cookies.get("dogNeutered") + ']').prop('checked', true);
    $(".gender-step").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".gender-step").find("button").removeAttr("disabled","");
  }
  if (Cookies.get("dogAgeStage")) {
    $('input[name=dog-0-ageStage][value=' + Cookies.get("dogAgeStage") + ']').prop('checked', true);
    $(".dog-age").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-age").find("button").removeAttr("disabled","");
  }
  if (Cookies.get("dogEatingHabit")) {
    $('input[name=dog-eating-habit][value=' + Cookies.get("dogEatingHabit") + ']').prop('checked', true);
    $(".dog-eating-habit").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-eating-habit").find("button").removeAttr("disabled","");
  }
  if (Cookies.get("dogBodyShape")) {
    $('input[name=dog-body][value=' + Cookies.get("dogBodyShape") + ']').prop('checked', true);
  }
  if (Cookies.get("dogActivity")) {
    $('input[name=dog-activity][value=' + Cookies.get("dogActivity") + ']').prop('checked', true);
    $(".dog-body-type").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-body-type").find("button").removeAttr("disabled","");
  }
  if (Cookies.get("dogHealth")) {
    $('input[name=dog-0-health][value=' + Cookies.get("dogHealth") + ']').prop('checked', true);
  }
  if (Cookies.get("dogNoAllergy")) {
    $('input[name=dog-0-no-allergies][value=' + Cookies.get("dogNoAllergy") + ']').prop('checked', true);
    $(".dog-health-issues").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-health-issues").find("button").removeAttr("disabled","");
  }
});


// $("input.birth-date").each(function() {
//   if (Cookies.get("dogDOB")) {
//     $(this).val(Cookies.get("dogDOB"));
//     $(".dog-age").removeClass("stickynavigation-module__disabled___1GDwt");
//     $(".dog-age").find("button").removeAttr("disabled","");
//   }
// });

$("input.breed-input").each(function() {
  if (Cookies.get("dogBreed")) {
    $(this).val(Cookies.get("dogBreed"));
    $(".dog-breed").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-breed").find("button").removeAttr("disabled","");
  }
});

if (Cookies.get("dogFood")) {
  var selectedItems = JSON.parse(Cookies.get("dogFood"));
  $('input[name=dog-0-food]').each(function() {
    if (selectedItems.includes($(this).val())) {
      $(this).prop('checked', true);
    }
  });
};


if (Cookies.get("dogAllergy")) {
  try {
      var selectedAllergies = JSON.parse(Cookies.get("dogAllergy"));
          $('input.yes-allergy').each(function() {
        if (selectedAllergies.includes($(this).val())) {
          $(this).prop('checked', true);
        }
      });
    } catch (e) {
      console.error('Error parsing JSON from cookies: ', e);
    }
  $(".dog-health-issues").removeClass("stickynavigation-module__disabled___1GDwt");
  $(".dog-health-issues").find("button").removeAttr("disabled","");
};

$("input#petParentFullName").each(function() {
  if (Cookies.get("dogOwnerName")) {
    $(this).val(Cookies.get("dogOwnerName"));
  }
});

$("input#petParentEmail").each(function() {
  if (Cookies.get("dogOwnerEmail")) {
    $(this).val(Cookies.get("dogOwnerEmail"));
    // $(".dog-account").removeClass("stickynavigation-module__disabled___1GDwt");
    // $(".dog-account").find("button").removeAttr("disabled","");
  }
});

$("input#petParentId").each(function() {
  if (Cookies.get("dogOwnerId")) {
    $(this).val(Cookies.get("dogOwnerId"));
    $('#petParentPassword').val(Cookies.get("dogOwnerId"));
  }
});

$("input#petParentMobile").each(function() {
  if (Cookies.get("dogOwnerMobile")) {
    $(this).val(Cookies.get("dogOwnerMobile"));
    $(".dog-account").removeClass("stickynavigation-module__disabled___1GDwt");
    $(".dog-account").find("button").removeAttr("disabled","");
  }
});

$(document).ready(function() {
  if (Cookies.get("dogOwnerId")) {
    $("input#petParentId").val(Cookies.get("dogOwnerId"));
  }
})